import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=046d81d1&scoped=true"
import script from "./Song.vue?vue&type=script&lang=js"
export * from "./Song.vue?vue&type=script&lang=js"
import style0 from "./Song.vue?vue&type=style&index=0&id=046d81d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d81d1",
  null
  
)

export default component.exports